import * as moment from 'moment';

export const CopyRightMessage = `© ${moment().format('YYYY')} Vertis Solutions. All Rights Reserved.`;
export const CopyRightVersion = "2.18.0";

export const ErrorUnexpected = "The system found an unexpected failure during execution. Please, try again in a few seconds.";
export const OperationSuccessfully = "Operation successfully executed.";
export const OperationCancelled = "Operation cancelled.";